<template>
  <div>
    <template v-if="bookingStep == 1">
      <v-card class="mb-3">
        <v-card-text>
          <div id="chart"></div>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-title>Избрани билети</v-card-title>
        <v-card-text>
          <div class="row ticket-details">
            <div class="col-12">
              <b>Вашите детайли:</b>
            </div>
            <div class="col-12 col-sm-4">
              <v-text-field
                v-model="client.name"
                label="Име и Фамилия"
                required
              ></v-text-field>
            </div>
            <div class="col-12 col-sm-4">
              <v-text-field
                v-model="client.email"
                label="Email"
                required
              ></v-text-field>
            </div>
            <div class="col-12 col-sm-4">
              <v-text-field
                v-model="client.phone"
                label="Телефон"
                required
              ></v-text-field>
            </div>

            <div class="col-12 text-center align-self-center">
              <v-alert
                :value="true"
                color="warning"
                icon="priority_high"
                outlined
                class="alert-box"
              >
                За да предотвратите неоторизирано използване на билетите, моля
                попълнете имената на хората, които ще присъстват на събитието.
                При нужда имената могат да бъдат променени на място преди
                събитието.
              </v-alert>
            </div>

            <template v-for="seat in selectedSeats">
              <div class="col-12 col-sm-6">
                <b>
                  Място: {{ getFormattedLabel(seat.label) }} &#8901; Цена:
                  {{ seat.price }} {{ currencySign }}
                </b>
                <br />

                <div class="row m-0">
                  <v-text-field
                    v-model="seat.name"
                    label="Име и Фамилия"
                    required
                  ></v-text-field>
                </div>
              </div>
            </template>
          </div>
          <div class="row">
            <div class="col">
              <tos-checkbox
                :is-valid="isGdprValid"
                @update-gdpr="(v) => (gdpr = v)"
              ></tos-checkbox>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-6 align-self-center">
              <h5 class="price-total">
                Общо: {{ currencySign }}{{ seatsTotal.toFixed(2) }}
              </h5>
            </div>
            <div class="col-6 justify-content-end text-right">
              <v-btn
                class="primary"
                @click="bookTickets()"
                :disabled="payBtnDisabled"
              >
                Плащане
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </template>
    <template v-if="bookingStep == 2">
      <Payment
        :selected-tickets="selectedSeats"
        :event="event"
        :amount="seatsTotal"
        :secret="secret"
        :enable-borika="true"
      ></Payment>
    </template>
  </div>
</template>

<script>
import Payment from './Payment'
import TosCheckbox from './components/TosCheckbox'

export default {
  name: 'SeatsIo',
  components: {
    Payment,
    TosCheckbox,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isGdprValid: true,
      gdpr: false,
      selectedSeats: [],
      selectedSeatsObjects: [],
      errors: [],
      payBtnDisabled: false,
      bookingStep: 1,
      client: {
        name: '',
        email: '',
        phone: '',
      },
      error: false,
      secret: '',
    }
  },
  computed: {
    seatsTotal() {
      let sum = 0
      this.selectedSeatsObjects.forEach((item) => {
        sum += parseFloat(item.pricing.price)
      })

      return sum
    },
    currencySign() {
      if (this.event.decoded_settings.currency === 'BGN') {
        return 'BGN'
      }
      if (this.event.decoded_settings.currency === 'GBP') {
        return '£'
      }
      if (this.event.decoded_settings.currency === 'USD') {
        return '$'
      }
      return '€'
    },
    pricing() {
      let prices = this.event.public_active_ticket_groups
      prices = prices.map((item) => {
        return {
          ...item,
          name: item.title,
          price: parseFloat(item.price * item.generated_per_ticket),
          generated_per_ticket: item.generated_per_ticket,
          category: item.title,
        }
      })

      console.log(prices)

      return prices
    },
  },
  created() {
    new seatsio.SeatingChart({
      divId: 'chart',
      workspaceKey: this.event.sio_public_workspace_key,
      event: this.event.sio_event_id,
      session: 'continue',
      pricing: [...this.pricing],
      priceFormatter: (price) => {
        return `Цена:${price}`
      },
      onObjectSelected: (object) => {
        // add the selected seat id to the array
        this.selectedSeats.push({
          id: object.id,
          name: '',
          label: object.label,
          price: object.pricing.price,
          category: object.category,
          sio: object,
        })
        this.selectedSeatsObjects.push(object)
      },
      onObjectDeselected: (object) => {
        // remove the deselected seat id from the array
        const index = this.selectedSeatsObjects.findIndex(
          (item) => item.label === object.label
        )
        if (index !== -1) this.selectedSeats.splice(index, 1)

        const objectIndex = this.selectedSeatsObjects.findIndex(
          (item) => item.label === object.label
        )
        if (objectIndex !== -1) this.selectedSeatsObjects.splice(objectIndex, 1)
      },
    }).render()
  },
  methods: {
    bookTickets() {
      if (!this.gdpr) {
        this.isGdprValid = false
        return
      }

      const data = {
        client: this.client,
        seats: this.selectedSeats,
      }
      axios
        .post(`/events/${this.event.id}/sio/book-tickets`, data)
        .then((response) => {
          this.secret = response.data.secret
          this.bookingStep = 2
        })
        .catch((error) => {
          alert(error.response.data.message)
        })
        .finally(() => {
          this.payBtnDisabled = false
        })
    },
    getFormattedLabel(label) {
      // $sioIdParts = isset($ticket->sio_id) ? explode('-', $ticket->sio_id) : [];
      const labelParts = label.split('-')

      if (labelParts.length === 3) {
        return `Сектор: ${labelParts[0]} Ред: ${labelParts[1]} Място: ${labelParts[2]}`
      }

      return label
    },
  },
}
</script>

<style scoped></style>
